export const TWITTER_URL_PREFIX = 'https://twitter.com';
export const WIDGET_TYPE = 'FOLLOW';
export const COMPONENT_LABEL = 'component_label';
export const TITLE_NAME = 'component_label_ twitterFollowTitle';
